import { Component, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";

@Component({
    selector: 'gravacao',
    templateUrl: './gravacao.component.html',
    styleUrls: ['./gravacao.component.scss'],
})
export class GravacaoComponent extends AppComponentBase {
    constructor(injector: Injector) { super(injector) }
}
